<div class="page-wrapper">

    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div>
    </div>



    <!-- PAGE HEADER -->

    <section class="page-header">

        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>

        <div class="container">

            <div class="page-header__inner">

                <div class="page-header__img-1">
                    <img src="assets/images/resources/page-header-img-1.png" alt="">
                </div>

                <div class="page-header__shape-1 float-bob-y">
                    <img src="assets/images/shapes/page-header-shape-1.png" alt="">
                </div>

                <h3>Ship Chandling Division


                </h3>

                <div class="thm-breadcrumb__inner">

                    <ul class="thm-breadcrumb list-unstyled">

                        <li>
                            <a href="index.html">Home</a>
                        </li>

                       

                        <li>
                            <span class="fas fa-angle-right"></span>
                        </li>

                        <li>Ship Chandling Division
</li>

                    </ul>

                </div>

            </div>

        </div>

    </section>



    <!-- SERVICE DETAILS -->

    <section class="service-details">
        <div class="container">
            <div class="row"> <!-- LEFT SIDEBAR -->

                <div class="col-xl-12 col-lg-12">
                    <div class="service-details__left"> <!-- PEPPER -->
                        <div class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-22.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Ship Chandling Division

                            </h3>
                            <p class="service-details__text-1">Shingad Shipping Lines Pvt Ltd provides reliable and
                                efficient Ship Chandling Services to vessels calling at Indian ports. We supply a wide
                                range of provisions, technical stores, deck and engine consumables, safety equipment,
                                and bonded stores to merchant ships, offshore vessels, dredgers, research vessels,
                                cruise ships, and naval support vessels.

                                <br><br>
                                Our experienced team ensures timely delivery, quality products, competitive pricing, and
                                compliance with port, customs, and maritime regulations.
                            </p>
                        </div> <!-- CARDAMOM -->


                    </div>
                </div>
            </div>
        </div>
    </section>


    <app-bees-footer></app-bees-footer>

</div>